export const ALGORITHM = {
  pageRank: 'pageRank',
  breadthFirstSearch: 'breadthFirstSearch',
  connectedComponent: 'connectedComponent',
  depthFirstSearch: 'depthFirstSearch',
  detectCycle: 'detectCycle',
  detectDirectedCycle: 'detectDirectedCycle',
  detectAllCycles: 'detectAllCycles',
  detectAllDirectedCycle: 'detectAllDirectedCycle',
  detectAllUndirectedCycle: 'detectAllUndirectedCycle',
  dijkstra: 'dijkstra',
  findAllPath: 'findAllPath',
  findShortestPath: 'findShortestPath',
  floydWarshall: 'floydWarshall',
  getAdjMatrix: 'getAdjMatrix',
  getDegree: 'getDegree',
  getInDegree: 'getInDegree',
  getNeighbors: 'getNeighbors',
  getOutDegree: 'getOutDegree',
  labelPropagation: 'labelPropagation',
  louvain: 'louvain',
  GADDI: 'GADDI',
  minimumSpanningTree: 'minimumSpanningTree',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};

export const MESSAGE = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};
